var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-l-5 m-b-10" }, [
    _c(
      "table",
      { staticClass: "table_beauty condensed-alternate routing-plan-args" },
      [
        _c("thead", [
          _c("tr", { staticClass: "bg-transparent" }, [
            _c("th", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: _vm.getRpcMessageTitle,
                  expression: "getRpcMessageTitle"
                }
              ]
            })
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.parsedRpcDetail, function(target, index) {
            return _c("tr", { key: index, staticClass: "bg-transparent" }, [
              _c("div", { staticClass: "p-l-10" }, [
                _c("td", [
                  _vm._v(
                    "\n            " + _vm._s(target.details) + "\n          "
                  )
                ])
              ])
            ])
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }